"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash.noop"));
var _memoizeOne = _interopRequireDefault(require("memoize-one"));
var _setHours = _interopRequireDefault(require("date-fns/setHours"));
var _setMinutes = _interopRequireDefault(require("date-fns/setMinutes"));
var _setSeconds = _interopRequireDefault(require("date-fns/setSeconds"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _styledComponents = require("styled-components");
var _oxygenConfig = require("@8x8/oxygen-config");
var Styled = _interopRequireWildcard(require("../styled"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var getTimeListItems = (0, _memoizeOne["default"])(function (selectedTimeValue, timeDisplayFormat) {
  var listItems = [];
  var minutes = [0, 15, 30, 45];
  for (var h = 0; h < 24; h += 1) {
    var _iterator = _createForOfIteratorHelper(minutes),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var m = _step.value;
        var listItem = {
          time: {
            hours: h,
            minutes: m,
            seconds: 0
          },
          formatted: (0, _format["default"])((0, _setHours["default"])((0, _setMinutes["default"])((0, _setSeconds["default"])(new Date(), 0 || 0), m), h), timeDisplayFormat)
        };
        listItems.push(listItem);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return listItems;
});
function TimeSelectorDropdown(_ref) {
  var selectedTimeValue = _ref.selectedTimeValue,
    timeDisplayFormat = _ref.timeDisplayFormat,
    testId = _ref.testId,
    onTimeSelect = _ref.onTimeSelect,
    style = _ref.style,
    dropdownRef = _ref.dropdownRef,
    theme = _ref.theme;
  var selectedItemRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var _selectedItemRef$curr, _selectedItemRef$curr2;
    (_selectedItemRef$curr = selectedItemRef.current) === null || _selectedItemRef$curr === void 0 ? void 0 : (_selectedItemRef$curr2 = _selectedItemRef$curr.scrollIntoView) === null || _selectedItemRef$curr2 === void 0 ? void 0 : _selectedItemRef$curr2.call(_selectedItemRef$curr);
  }, [selectedTimeValue]);
  var timeListItems = getTimeListItems(selectedTimeValue, timeDisplayFormat);
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(Styled.PopperContainer, {
    ref: dropdownRef,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(Styled.DropdownContainer, (0, _oxygenConfig.getTestAttributes)(testId), timeListItems.map(function (_ref2) {
    var time = _ref2.time,
      formatted = _ref2.formatted;
    var isSelected = selectedTimeValue.hours === time.hours && selectedTimeValue.minutes === time.minutes && (selectedTimeValue.seconds === time.seconds || !selectedTimeValue.seconds);
    return /*#__PURE__*/_react["default"].createElement(Styled.ListItem, _extends({
      key: formatted
    }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_ITEM_").concat(time.hours, "_").concat(time.minutes, "_").concat(time.seconds)), {
      onMouseDown: function onMouseDown() {
        return onTimeSelect(time);
      },
      isSelected: isSelected
    }, isSelected && {
      ref: selectedItemRef
    }), formatted);
  }))));
}
TimeSelectorDropdown.propTypes = {
  selectedTimeValue: _propTypes["default"].shape({
    hours: _propTypes["default"].number,
    minutes: _propTypes["default"].number,
    seconds: _propTypes["default"].number
  }).isRequired,
  timeDisplayFormat: _propTypes["default"].string.isRequired,
  testId: _propTypes["default"].string,
  onTimeSelect: _propTypes["default"].func,
  dropdownRef: _propTypes["default"].func,
  style: _propTypes["default"].object,
  theme: _propTypes["default"].object.isRequired
};
TimeSelectorDropdown.defaultProps = {
  testId: 'TIME_SELECTOR_DROPDOWN',
  onTimeSelect: _lodash["default"],
  dropdownRef: _lodash["default"],
  style: undefined
};
var _default = TimeSelectorDropdown;
exports["default"] = _default;